// WorkOrderService.tsx
import { BaseService } from '../../core/BaseService';
import { PaginationParams } from '../../type';
import { GetWorkOrderByIdResponse, GetWorkOrderResponse } from './interface';

export class WorkOrderProfile extends BaseService {
  async getWorkOrder(params: PaginationParams) {
    return this.get<GetWorkOrderResponse>(`${this.apiUrl}/api/workorders/paged`, params);
  }

  async getWorkOrderByID(id: number) {
    return this.get<GetWorkOrderByIdResponse>(`${this.apiUrl}/api/workorders/${id}`);
  }
}
